module.exports = __webpack_public_path__ + "img/production.577c8fd0.svg";